import { GenerationForecastModel } from "models/generationForecast/generationForecastModel";

export const compareForecastDate = (
  a: GenerationForecastModel,
  b: GenerationForecastModel
): number =>
  new Date(a.forecastDate).getTime() - new Date(b.forecastDate).getTime();
